import { createSlotRecipe } from './runtime.js';

const checkboxConfig = {"name":"checkbox","slots":["root","control","indicator","content","label","description"],"defaultVariants":{"size":"sm"},"variantMap":{"size":["md","sm"]}}

export const checkbox = /* @__PURE__ */ createSlotRecipe(checkboxConfig)